/**
 * 遥测。
 *
 * PWA 的失败绝大多数是**静默**的：图标没换成、订阅失效了、SW 没更新、深链落错了页面。
 * 用户不会报障，他只会少用。所以框架把这些关键节点全部打成事件——默认只往 console 打，
 * 接不接后端由项目决定，但事件本身必须在。
 *
 * 事件是**闭集**（联合类型）。加事件要改这里，改这里就会在所有消费方暴露出来，
 * 而不是散落的字符串。
 */
export const consoleSink = (event) => {
    // 一行一条、带前缀，便于真机上用 Safari/Chrome 远程调试时 grep
    console.info(`[pwaship] ${event.type}`, event);
};
export const noopSink = () => { };
export function createTelemetry(initial = [consoleSink]) {
    const sinks = new Set(initial);
    return {
        emit(event) {
            const stamped = { ...event, at: Date.now() };
            for (const sink of sinks) {
                try {
                    sink(stamped);
                }
                catch {
                    // 遥测自己出错绝不能影响主流程
                }
            }
        },
        addSink(sink) {
            sinks.add(sink);
            return () => sinks.delete(sink);
        },
    };
}
//# sourceMappingURL=telemetry.js.map